import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  protected readonly API_URL = environment.API_URL;

  constructor(protected http: HttpClient) {}
}
